import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  log(value:any|Array<unknown>):void {
    if (Array.isArray(value)) {
      return console.table(value);
    }
    return console.log(value);
  }
}
